import src from "IMAGE";
export default { src, width: 260, height: 80, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AJJ2dpSve2K0bXd8lQZNjaspYpSsaXmMlI6Tq7R9gZOZAJJ2dpSve2K0bXd8lQZNjassZJWsbHqNlI6Tq7R8gJKZJLkgm6IIxCwAAAAASUVORK5CYII="};
